import { ChannelFilters, StreamChat } from 'stream-chat';
import { CustomChannelData, CustomChannelFields } from './ChatUtils';

export default async function fetchMissingDispatcherChannels(client: StreamChat) {
  if (!client) return;
  const filters: ChannelFilters & CustomChannelFields = { channel_member_state: 'missing_disp' };
  const sort = [{ name: 1 }];
  const missingDispChannels = await client.queryChannels(filters, sort, { watch: false, limit: 11 });
  if (missingDispChannels.length == 0) {
    return undefined;
  }

  const dispNames = missingDispChannels
    .slice(0, 10)
    .map((channel) => (channel?.data as CustomChannelData)?.name)
    .join('\n');
  if (missingDispChannels.length <= 10) {
    return dispNames;
  }
  return [dispNames, '...'].join('\n');
}
